import {
  Box,
  Card,
  CardContent,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import {
  CartesianGrid,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import apiService from "../Services/api.service";
import PageLoader from "./Loader";
// Replace this with your actual API function
// Example: import apiService from "../services/apiService";

const OverAllDaywise = ({}) => {
  const currentYear = new Date().getFullYear();
  const theme = useTheme();
  const auth = localStorage.getItem("token");
  const [month, setMonth] = useState(dayjs().format("MMMM")); // e.g. "June"
  const [year, setYear] = useState(currentYear.toString());
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const years = Array.from({ length: currentYear - 2020 + 1 }, (_, i) =>
    (2020 + i).toString()
  ).reverse();

  const getChartData = async () => {
    setLoading(true);
    try {
      // Convert month name to month number, pad with zero
      const monthNumber = (months.indexOf(month) + 1)
        .toString()
        .padStart(2, "0");

      const startDate = `01/${monthNumber}/${year}`;
      const daysInMonth = dayjs(
        `${year}-${monthNumber}`,
        "YYYY-MM"
      ).daysInMonth();
      const endDate = `${daysInMonth
        .toString()
        .padStart(2, "0")}/${monthNumber}/${year}`;

      const res = await apiService.getDayWiseData(auth, startDate, endDate);

      const sorted = [...res.data].sort(
        (a, b) =>
          dayjs(a.date, "DD MMMM YYYY").valueOf() -
          dayjs(b.date, "DD MMMM YYYY").valueOf()
      );

      setData(sorted);
    } catch (err) {
      console.error("Error loading chart data", err);
    }
    setLoading(false);
  };

  useEffect(() => {
    getChartData();
  }, [month, year]);
  const totalCount = data.reduce((sum, item) => sum + item.count, 0);
  return (
    <Card sx={{  borderRadius: "12px", p: 2 }}>
      <CardContent>
        <Box display="flex" alignItems="center" gap={2} mb={2}>
          <Typography variant="h6" fontWeight="bold">
            Total scans in {month}
          </Typography>
          <FormControl size="small" sx={{ minWidth: 120 }}>
            <InputLabel>Month</InputLabel>
            <Select
              value={month}
              onChange={(e) => setMonth(e.target.value)}
              label="Month"
            >
              {months.map((m) => (
                <MenuItem key={m} value={m}>
                  {m}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl size="small" sx={{ minWidth: 120 }}>
            <InputLabel>Year</InputLabel>
            <Select
              value={year}
              onChange={(e) => setYear(e.target.value)}
              label="Year"
            >
              {years.map((y) => (
                <MenuItem key={y} value={y}>
                  {y}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>

        <Typography sx={{ mt: 2, mb: 1 }} variant="body2">
          Total scans detected {month} {year}
        </Typography>
        <Typography variant="h4" fontWeight={600} sx={{ mb: 3 }}>
          {totalCount.toLocaleString()}
        </Typography>
        <ResponsiveContainer width="100%" height={350}>
          <LineChart data={data}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis
              dataKey="date"
              tickFormatter={(date) =>
                dayjs(date, "DD MMMM YYYY").format("DD-MM")
              }
              interval={2}
              angle={-30}
              textAnchor="end"
            />
            <YAxis />
            <Tooltip
              labelFormatter={(value) =>
                dayjs(value, "DD MMMM YYYY").format("DD MMM, YYYY")
              }
            />
            <Line
              type="monotone"
              dataKey="count"
              stroke={theme.Bars.secondary}
              strokeWidth={2}
              dot={{ r: 3 }}
              activeDot={{ r: 6 }}
            />
          </LineChart>
        </ResponsiveContainer>
      </CardContent>
      {loading && <PageLoader />}
    </Card>
  );
};

export default OverAllDaywise;
